import { requestAndParse, requestSuccessful } from '../request';

const deleteParticipantDocument = async (documentId: number) => {
    const route = 'admin/delete-participant-document';
    const payload = { documentId };

    const response = await requestAndParse(route, payload, 'DELETE');

    const success = requestSuccessful(response);
    const message = response.body?.message as string;

    return { success, message };
};

export default deleteParticipantDocument;
